import { Outlet, Route } from "react-router-dom"
import { RouteConfig } from "~/routes"

export const renderRoutes = (routes: RouteConfig[]): JSX.Element[] => {
  return routes.map((route, index) => {
    if (route.routes && route.routes.length > 0) {
      const element = route.layout ? route.layout : <Outlet />
      return (
        <Route key={index} path={route.path} element={element}>
          {renderRoutes(route.routes)}
        </Route>
      )
    }

    return <Route key={index} path={route.path} element={route.component} />
  })
}
